//WORD_TRIMMER
export const wordsTrimer = (
  str: string,
  limit: number,
  isDisabled?: boolean
) => {
  if (isDisabled) return str;
  let words = str?.split(" ");
  return (
    words?.slice(0, limit)?.join(" ") + (words?.length > limit ? "..." : "")
  );
};
